mutation DeleteDripSequence($id: ID!) {
    campaignDelete(input: {id: $id}) {
        campaign {
            id
        }
    }
}
